export default __webpack_public_path__ + "images/1f59c7c42f7c3695c47f7ef40156933a-democratic_party.webp";